import React from 'react';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import SearchInput from '../form/SearchInput';
import SortableList from '../shared/SortableList';
import ListItem from '../shared/ListItem';
import Pagination from '../shared/Pagination';
import Loader from '../shared/Loader';
import { maskServiceWeek, maskLiveDate, maskRichText } from '../../masks';
import { debounce } from '../../helpers/util';

class MenusWeekly extends React.Component {
  state = {
    menus: [],
    searchTerm: '',
    sortBy: [],
    isLoading: false,
    pagination: {},
    loaded: false
  };

  sections = {
    live: {
      label: 'Live',
      // sortable values are taken from this section only
      columns: [
        {
          label: 'Menu Name',
          class: 'menu__td--name',
          link: { to: '/admin/menu/[id]', advancedLabel: { key: 'name' } }
        },
        {
          label: 'Service Week',
          key: 'service_week',
          mask: maskServiceWeek,
          class: 'menu__td--service-week'
        },
        {
          label: 'Live Since',
          key: 'service_week',
          mask: maskLiveDate,
          sortable: false,
          class: 'menu__td--live-week'
        },
        {
          label: 'Notes',
          key: 'notes',
          sortable: false,
          mask: maskRichText,
          class: 'menu__td--notes'
        },
        {
          sortable: false,
          link: { to: '/admin/menu/[id]', label: 'Edit' },
          class: 'menu__td--edit'
        }
      ]
    },
    queued: {
      label: 'Queue',
      columns: [
        {
          label: 'Menu Name',
          class: 'menu__td--name',
          link: { to: '/admin/menu/[id]', advancedLabel: { key: 'name' } }
        },
        {
          label: 'Service Week',
          key: 'service_week',
          mask: maskServiceWeek,
          class: 'menu__td--service-week'
        },
        {
          label: 'Going Live On',
          key: 'service_week',
          mask: maskLiveDate,
          sortable: false,
          class: 'menu__td--live-week'
        },
        {
          label: 'Notes',
          key: 'notes',
          sortable: false,
          mask: maskRichText,
          class: 'menu__td--notes'
        },
        {
          sortable: false,
          link: { to: '/admin/menu/[id]', label: 'Edit' },
          class: 'menu__td--edit'
        }
      ]
    },
    drafted: {
      label: 'Drafts',
      columns: [
        {
          label: 'Menu Name',
          class: 'menu__td--name',
          link: { to: '/admin/menu/[id]', advancedLabel: { key: 'name' } }
        },
        {
          label: 'Service Week',
          key: 'service_week',
          mask: maskServiceWeek,
          class: 'menu__td--service-week'
        },
        { raw: ' ', sortable: false, class: 'menu__td--live-week' },
        {
          label: 'Notes',
          key: 'notes',
          sortable: false,
          mask: maskRichText,
          class: 'menu__td--notes'
        },
        {
          sortable: false,
          link: { to: '/admin/menu/[id]', label: 'Edit' },
          class: 'menu__td--edit'
        }
      ]
    },
    past: {
      label: 'Past',
      columns: [
        {
          label: 'Menu Name',
          class: 'menu__td--name',
          link: { to: '/admin/menu/[id]', advancedLabel: { key: 'name' } }
        },
        {
          label: 'Service Week',
          key: 'service_week',
          mask: maskServiceWeek,
          class: 'menu__td--service-week'
        },
        {
          label: 'Went Live On',
          key: 'service_week',
          mask: maskLiveDate,
          sortable: false,
          class: 'menu__td--live-week'
        },
        {
          label: 'Notes',
          key: 'notes',
          sortable: false,
          mask: maskRichText,
          class: 'menu__td--notes'
        },
        {
          sortable: false,
          link: { to: '/admin/menu/[id]', label: 'Edit' },
          class: 'menu__td--edit'
        }
      ]
    }
  };

  render() {
    const { handleSearch, handlePaginate, sections } = this;
    const { searchTerm, pagination, loaded } = this.state;
    const sectionPairs = Object.entries(sections);
    return (
      <div className="menu-manager">
        {loaded ? (
          <div>
            <p className="p p--dark-taupe">
              {pagination.total_items || 0} Total
            </p>
            <SearchInput
              placeholder="Search Weekly Menus"
              value={searchTerm}
              onChange={handleSearch}
            />

            {sectionPairs.map(([status, section], i) =>
              this.renderList(i, status, section)
            )}
            <div className="cms__pagination">
              <Pagination
                pageCount={pagination.total_pages || 1}
                forcePage={pagination.current_page - 1 || 0}
                onPageChange={handlePaginate}
              />
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </div>
    );
  }

  renderList(i, status, section) {
    const { handleSort } = this;
    const { menus, sortBy, isLoading } = this.state;
    const filteredMenus = menus.filter(menu => menu.status === status);
    if (filteredMenus.length > 0)
      return (
        <div className="menu-list-group" key={i}>
          <h3 className="h3">{section.label}</h3>
          <div className="cms__list-wrap">
            <SortableList
              columns={section.columns}
              rows={filteredMenus}
              sort={sortBy}
              ListItem={ListItem}
              handleSort={handleSort}
              isLoading={isLoading}
            />
          </div>
        </div>
      );
  }

  handleSort = prop => {
    const column = this.sections.live.columns.find(c => c.key === prop);
    const isSortable = !column.sortable || column.sortable !== false;
    // don't do anything is the property is marked as `sortable: false`
    if (!isSortable) return;

    let { sortBy } = this.state;

    const index = sortBy.findIndex(option => prop in option);
    if (index >= 0 && sortBy[index][prop] === 'asc') {
      sortBy[index][prop] = 'desc';
    } else if (index >= 0 && sortBy[index][prop] === 'desc') {
      sortBy = [
        ...sortBy.slice(0, index),
        ...sortBy.slice(index + 1, sortBy.length)
      ];
    } else {
      sortBy.push({ [prop]: 'asc' });
    }
    this.setState({ sortBy }, this.debouncedLoadMenus);
  };

  handlePaginate = ({ selected: page }) => {
    this.loadMenus(page + 1);
  };

  // search
  handleSearch = e => {
    const { value: searchTerm } = e.target;
    this.setState({ searchTerm }, this.debouncedLoadMenus);
  };

  loadMenus(page = 1) {
    if (this.state.isLoading === true) return;

    const { searchTerm: name, sortBy: sort } = this.state;
    // clear existing
    this.setState({ menus: [], isLoading: true });

    menuAPI
      .searchMenus({
        search: { name, occurrence: 'weekly' },
        sort,
        page,
        hide_details: true
      })
      .then(({ menus, pagination }) =>
        this.setState({ menus, pagination, isLoading: false, loaded: true })
      )
      .catch(error => console.log(error));
  }

  debouncedLoadMenus = debounce(() => this.loadMenus(), 250);

  componentDidMount() {
    this.loadMenus();
  }
}

export default MenusWeekly;



// WEBPACK FOOTER //
// ./src/components/menus/MenusWeekly.js